module.exports = __webpack_public_path__ + "bfd3b4be7e1c20c23c120100c5ca8897.svg";